import React from 'react'
import {
    Form,
    Button
} from 'antd'

import { 
    SendOutlined
} from '@ant-design/icons'

import useEnqueueReport from './useEnqueueReport'

export const pad = (n: any, width: any, z = '0') => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export default function ReportPendingInvoice() {
    const { enqueue, submitting: loading } = useEnqueueReport('pendings')
    const [form] = Form.useForm()
    
    const onFinish = (data: any) => {
        enqueue(data)
    }

    return <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} form={form} onFinish={onFinish} initialValues={{
        periodo: `${new Date().getFullYear()}${pad(new Date().getMonth() + 1, 2)}`
    }}>
        <p>Puedes solicitar el informe sobre todos los documentos pendientes de facturar en el sistema.</p>
        <br />
        <Button type="primary" htmlType="submit" loading={loading} icon={<SendOutlined />} className='Accounting--DownloadBtn' >
          Solicitar Informe
        </Button>
    </Form>
}
